import { parse } from 'graphql';

// schemas
const sessionSchema = `
  id
  name
  workspace
  codeSiteComptage
  start_time
  end_time
  max_participant
  capacity
  activity
  participants
  product_activity {
    product
    activity
  }
  products
  recurring
  recurring_uuid
  end_recurring_date
  pre_reserved_participants {
    items {
      id
    }
  }`;

const subscriptionSessionSchema = `
  id
  name
  workspace
  codeSiteComptage
  start_time
  end_time
  max_participant
  participantsAmount
  capacity
  activity
  product_activity {
    product
    activity
  }
  products
  isTerrainSession
  recurring
  recurring_uuid
  end_recurring_date
  pre_reserved_participants {
    items {
      id
    }
}`;

export const onDeleteParticipantFromSession = parse(`
  subscription onDeleteParticipantFromSession($filter: SessionFilterInput) {
    onDeleteParticipantFromSession(filter: $filter) {
      ${subscriptionSessionSchema}
    }
  }
`);

export const onAddParticipantToSession = parse(`
  subscription onAddParticipantToSession($filter: SessionFilterInput) {
    onAddParticipantToSession(filter: $filter) {
      ${subscriptionSessionSchema}
    }
  }
`);

export const onHandleCreateEditSession = parse(`
  subscription onHandleCreateEditSession($filter: SessionFilterInput) {
    onHandleCreateEditSession(filter: $filter) {
      ${subscriptionSessionSchema}
    }
  }
`);

export const onHandleUpdateReplicaSessions = parse(`
  subscription onHandleUpdateReplicaSessions {
    onHandleUpdateReplicaSessions {
      create {
        ${subscriptionSessionSchema}
      }
      edit {
        ${subscriptionSessionSchema}
      }
      delete {
        id
      }
    }
  }
`);

export const onUpdateSession = parse(`
  subscription OnUpdateSession($filter: ModelSubscriptionSessionFilterInput) {
    onUpdateSession(filter: $filter) {
      ${sessionSchema}
    }
  }
`);

export const onDeleteSession = parse(`
  subscription OnDeleteSession($filter: ModelSubscriptionSessionFilterInput) {
    onDeleteSession(filter: $filter) {
      id
      start_time
    }
  }
`);
